import { IconButton, useToast } from '@thirstycamel/ui'
import { useUser } from '../../hooks/useUser'
import { useActions, useStore } from '../../store/hooks'
import { useState } from 'react'
import { getNiceErrorMessage } from '../../utils/getNiceErrorMessage'
import { eventGA4, eventUA } from '../../utils/gtag'

export const ProductFavouriteStatus = ({ productId }: { productId: string }) => {
  const toast = useToast()
  const { user } = useUser()
  const { isFetching } = useStore(store => store.auth)
  const { updateUser } = useActions(store => store.auth)

  const isFav = user?.favouriteProducts?.find(product => product.id === productId)

  /* Only logged in users can use this function */
  if (!user) {
    return null
  }

  const handleToggle = async () => {
    try {
      await updateUser({
        favouriteProducts: !isFav
          ? [...user.favouriteProducts, { id: productId }]
          : user.favouriteProducts.filter(p => p.id !== productId),
      })

      toast({
        title: 'Favourites updated!',
        description: `This product has been ${
          !isFav ? 'added to' : 'removed from'
        } your favourites`,
        status: 'success',
        isClosable: true,
      })

      if (!isFav) {
        /* Send to Google Analytics */
        eventUA('add_to_wishlist', {
          event_category: 'ecommerce',
          event_label: 'Favourited product',
          currency: 'AUD',
          items: [{ id: productId }],
        })

        eventGA4('add_to_wishlist', {
          currency: 'AUD',
          items: [{ item_id: productId }],
        })

        /* Send to Facebook Pixel */
        if (typeof fbq !== 'undefined') {
          fbq?.('track', 'AddToWishlist', { content_ids: [productId] })
        }
      }
    } catch (e) {
      toast({
        title: 'Error updating your favourites',
        description: getNiceErrorMessage(e),
        status: 'error',
        isClosable: true,
      })
    }
  }

  return (
    <IconButton
      color="pink.500"
      icon={isFav ? 'heart' : 'heart-outline'}
      variant="ghost"
      isLoading={isFetching}
      _focus={{ outline: 0 }}
      onClick={handleToggle}
      fontSize="3xl"
    />
  )
}

export default ProductFavouriteStatus
